// http-interceptor.service.ts
import { Injectable } from '@angular/core';
import {
  HttpRequest,
  HttpHandler,
  HttpEvent,
  HttpInterceptor,
} from '@angular/common/http';
import { BehaviorSubject, catchError, filter, Observable, switchMap, take, throwError } from 'rxjs';
import { UserService } from './services/user-service';

@Injectable()
export class CircleHttpInterceptor implements HttpInterceptor {
  isRefreshing = false
  private refreshTokenSubject: BehaviorSubject<string | null> = new BehaviorSubject<string | null>(null)

  constructor(private userService: UserService){}

  intercept(
    request: HttpRequest<any>,
    next: HttpHandler
  ): Observable<HttpEvent<any>> {
    // Modify the request before sending it to the server
    // For example, adding headers, authentication, etc.
    request.headers.set('Observe', `response`)
    const modifiedRequest = this.addToken(request)

    // Continue with the modified request
    return next.handle(modifiedRequest).pipe(
      catchError((error) => {
        if (error.status === 401 && !this.isRefreshing) {
          return this.refreshToken(modifiedRequest, next);
        }
        return throwError(() => error);
      })
    );
  }

  private addToken(request: HttpRequest<any>) {
    /*
     * @todo move the storage from localStorage to cookies.
     */
    const token = localStorage.getItem('token')
    return request.clone({
      setHeaders: {
        Authorization: `Bearer ${token}`
      }
    });
  }

  private refreshToken(request: HttpRequest<any>, next: HttpHandler) {
    if (!this.isRefreshing) {
      this.isRefreshing = true;
      this.refreshTokenSubject.next(null);

      return this.userService.refreshAccessToken().pipe(
        switchMap((tokenResponse) => {
          this.isRefreshing = false;
          //no need to add token here as it is added in the refreshToken see userService.
          this.refreshTokenSubject.next(tokenResponse.access.token);
          return next.handle(this.addToken(request));
        }),
        catchError((error) => {
          this.isRefreshing = false;
          this.userService.logout();
          return throwError(() => error);
        })
      );
    } else {
      return this.refreshTokenSubject.pipe(
        filter((token) => token !== null),
        take(1),
        switchMap((token) => next.handle(this.addToken(request)))
      );
    }
  }
}